import city from '@/js/city'
export default {
    namespaced: true,
    state: {
        city
    },
    getters: {
        getCity(state) {
            return state.city.map(item => {
                return {
                    adCode: item.adCode,
                    cityCode: item.cityCode,
                    id: item.id,
                    latitude: item.latitude,
                    longitude: item.longitude,
                    name: item.name,
                    children:item.cities.map(item => {
                        return ({
                            adCode: item.adCode,
                            cityCode: item.cityCode,
                            id: item.id,
                            latitude: item.latitude,
                            longitude: item.longitude,
                            name: item.name,
                            children: item.counties.map(item => ({
                                adCode: item.adCode,
                                cityCode: item.cityCode,
                                id: item.id,
                                latitude: item.latitude,
                                longitude: item.longitude,
                                name: item.name
                            }))
                        })
                    })
                }
            })
        },
    },
    mutations: {
    },
    actions: {

    }
}